import { CustomerPageWrapper } from 'components';
import TimelineComp from 'components/Timeline/TimelineComp';

export default function Timeline() {
  return (
    <CustomerPageWrapper>
      <TimelineComp />
    </CustomerPageWrapper>
  );
}
